/**
 * genericErrorModalButtons.tsx
 */
import Container from '@components/atoms/container/modalButtons';
import Focus from '@shared/types/enums/focus';
import ModalButton from '@components/elements/buttons/ui/modalButton';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { clearModal } from '@shared/store/slices/modal.slice';
import { popFocus, pushFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useEffect } from 'react';

/**
 * Displays the generic error modal buttons.
 */
export default function GenericErrorModalButtons() {
  const dispatch = useAppDispatch();

  const closeError = () => {
    dispatch(popFocus());
    dispatch(clearModal());
  };

  // Effect hooks

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  // Keyboard hooks

  useKeyboard({
    focus: Focus.MODAL_BUTTONS,
    stopPropagation: true,
    keyDownHandler: (key: string) => {
      switch (key) {
        case 'BACK':
        case 'SELECT':
          closeError();
          break;
      }
    },
  });

  return (
    <Container>
      <ModalButton
        text='MODAL.GENERIC_ERROR.CLOSE'
        releaseAction={() => closeError()}
      />
    </Container>
  );
}
